import cx from 'classnames'
import { useIntl } from 'react-intl'

import Money from '../Money/Money'
import TicketPart from './components/TicketPart/TicketPart'
import TicketSeat from './components/TicketSeat/TicketSeat'

import './Ticket.scss'

const Ticket = ({ seat, type, price, className }) => {
    const intl = useIntl()

    return (
        <div className={cx('ticket ticket__classic', className)}>
            <TicketSeat seat={seat} />
            <TicketPart className={'border-radius-right border-radius-left'}>
                <div className={cx('price-container', type === 'club' ? 'text-magentaSecondary' : 'text-basePrimary')}>
                    <Money amount={price?.amount} currency={price?.currency} />
                </div>
            </TicketPart>
        </div>
    )
}

export default Ticket
